import { getApiUrl } from "@repo/utils/get-api-url";
import type { GetNavigationParams, NavigationResponse } from "./types";

export async function getNavigation({
  requestInstance,
  requestContext: { shop, countryCode, lang, keyStoreDataversion },
}: GetNavigationParams): Promise<NavigationResponse> {
  const searchParams = new URLSearchParams({
    country: countryCode,
    lang,
    shop,
    keyStoreDataversion,
  });

  const url = getApiUrl({
    path: "/fashion/navigation/v2/tree",
    searchParams: Object.fromEntries(searchParams.entries()),
  });

  const response = await requestInstance.get<NavigationResponse>(
    url,
    undefined,
    {
      requestType: "NAVIGATION_API",
    },
  );

  return response.data;
}
